import React, {useEffect, useState} from 'react'
import {Row, Col, Form, DatePicker, Select, Spin} from 'antd'
import axios from 'axios'
import moment from 'moment'
import {Input} from 'antd'
import apiRequest from '../../hooks/ApiRequest'
import {toast} from 'react-toastify'

const EditPolicyPopUp = props => {
  const [loader, setLoader] = useState(false)
  const {Option} = Select
  const productNameInLocalStorage = localStorage.getItem('productName')

  const [address, setAddress] = useState()
  const [itempstartdate, setStartDate] = useState()
  const [itempexpirydate, setExpiryDate] = useState()
  const [annualPremium, setAnnualPremium] = useState()
  const [termPremium, setTermPremium] = useState()
  const [riskCover, setRiskCover] = useState()
  const [policy_cover, setPolicyCover] = useState()
  const [riskitemname, setRiskItemName] = useState()
  const [rate, setRate] = useState()
  const [prorata, setProrataPremium] = useState()
  const [suminsured, setSumInsured] = useState()
  //   const [riskcoverid, setRiskCoverId] = useState()
  //   const [riskname, setRiskName] = useState()
  //   const [dataItem, setDataItem] = useState([])
  //   const [riskItem, setRiskItem] = useState([])
  const [policyRiskItemId, setPolicyRiskItemId] = useState()
  const [policy_cover_id, setPolicyCoverId] = useState()
  const [riskitemid, setRiskItemId] = useState()
  const [policynumber, setPolicyNumber] = useState()
  const [stampDuty, setStampDuty] = useState()
  const [dateFormat, setDateFormat] = useState('YYYY-MM-DD')
  const [effectiveDate, setEffectiveDate] = useState()
  const [policyid, setPolicyid] = useState(0)
  const [productId, setProductId] = useState(0)

  // FCP State variables
  const [membername, setMembername] = useState()
  const [premiumfactor, setPremiumfactor] = useState()
  const [monthlypremium, setMonthlypremium] = useState()
  const [age, setAge] = useState(0)

  // HCP State variables
  const [riskCoverListForHCP, setRiskCoverListForHCP] = useState([])
  const [riskItemListForHCP, setRiskItemListForHCP] = useState([])
  const [riskCoverIdForHCP, setRiskCoverIdForHCP] = useState(0)
  const [riskItemIdForHCP, setRiskItemIdForHCP] = useState(0)

  const fetchData = async (policyRiskItemId, productId) => {
    setProductId(productId)
    try {
      setLoader(true)
      const response = await apiRequest(
        process.env.REACT_APP_BASE_URL +
          `/Policy/GetPolicyRiskItemDetailsById/${policyRiskItemId}`, 'GET'
      )
      const data = response.data
      console.log(response.data)
      console.log(localStorage.productId)
      setSumInsured(data.suminsured)
      setAddress(data.address)
      setAnnualPremium(data.annualpremium)
      setTermPremium(data.termpremium)
      setStartDate(data.itempstartdate)
      setExpiryDate(data.itempexpirydate)
      setPolicyCover(data.policy_cover)
      setRiskCover(data.riskCover)
      setRate(data.rate)
      setRiskItemName(data.riskitemname)
      setPolicyRiskItemId(data.policyriskitemid)
      setPolicyNumber(data.policynumber)
      setRiskItemId(data.riskitemid)
      setPolicyCoverId(data.policy_cover_id)
      setEffectiveDate(new Date())
      setProrataPremium(data.prorata)
      setPolicyid(data.policyid)

      // FCP state variables
      setMembername(data.membername)
      setPremiumfactor(data.premiumfactor)
      setMonthlypremium(data.monthlypremium)
      setAge(data.age)
      setLoader(false)
    } catch (error) {
      setLoader(false)
      console.error('Error fetching data:', error)
    }
  }

  const fetchRiskCovers = async () => {
    await fetch(
      process.env.REACT_APP_BASE_URL +
        '/Product/GetGloabalList/' +
        localStorage.getItem('productId') +
        ',' +
        localStorage.getItem('productId'),
    )
      .then(res => res.json())
      .then(data => {
        console.log(data)
        setRiskItemListForHCP(data.result.riskitemlist)
        setRiskCoverListForHCP(data.result.riskcoverlist)
      })
  }

  const fetchRiskItems = async () => {}

  const initialValues = {
    policyriskitemid: 0,
    policynumber: '',
    riskitemid: '',
    riskitemname: '',
    address: '',
    rate: 0,
    annualpremium: 0,
    termpremium: 0,
    suminsured: 0,
    prorata: 0,
    policyid: 0,
    itempstartdate: '',
    itempexpirydate: '',
    effectivedate: '',
    policy_cover: '',
    policy_cover_id: 0,
    refund: 0,
    collectiblepremium: 0,
    collectiblestampduty: 0,
  }

  const initialValuesForFCP = {
    policyriskitemid: 0,
    policynumber: '',
    riskitemid: '',
    riskitemname: '',
    address: '',
    rate: 0,
    annualpremium: 0,
    termpremium: 0,
    suminsured: 0,
    prorata: 0,
    policyid: 0,
    itempstartdate: '',
    itempexpirydate: '',
    policy_cover: '',
    policy_cover_id: 0,
    membername: '',
    gender: '',
    relationship: '',
    grand_total: 0,
    age: 0,
    monthlypremium: 0,
    premiumfactor: 0,
  }

  useEffect(() => {
    console.log(props.policyRiskItemId, props.productId)
    initialValues.policyRiskItemId = props.policyRiskItemId
    fetchData(props.policyRiskItemId, props.productId)
    if (props.productId == 5) {
      fetchRiskCovers()
      fetchRiskItems()
    }
  }, [props?.policyNumber && props.productId])

  const changeEffectiveDate = datestring => {
    setEffectiveDate(
      datestring._d.getFullYear() +
        '-' +
        (datestring._d.getMonth() + 1) +
        '-' +
        datestring._d.getDate(),
    )
  }

  const changeAddress = e => {
    setAddress(e.target.value)
  }

  const changeMembersName = e => {
    setMembername(e.target.value)
  }

  useEffect(() => {
    if (localStorage.productId != 3) {
      var numberOfDays =
        findDayDifference(new Date(effectiveDate), new Date(itempexpirydate)) +
        1
      setAnnualPremium(roundvalue((suminsured / 100) * rate))
      setStampDuty(roundvalue((annualPremium / 100) * 5))
      setProrataPremium(
        roundvalue((suminsured / 100) * rate * (numberOfDays / 365)),
      )
    } else if (localStorage.productId == 3) {
      var premFactor = suminsured / 1000
      setPremiumfactor(roundvalue(premFactor))
    }
  }, [suminsured])

  useEffect(() => {
    setMonthlypremium(roundvalue(premiumfactor * rate))
  }, [premiumfactor])

  useEffect(() => {
    setTermPremium(roundvalue(annualPremium / 3))
  }, [annualPremium])

  const handleSubmit = async (e) => {
    e.preventDefault()
    if (localStorage.productId != 3 && localStorage.productId != 5) {
      initialValues.address = address
      initialValues.annualpremium = annualPremium
      initialValues.termpremium = termPremium
      initialValues.itempstartdate = itempstartdate
      initialValues.itempexpirydate = itempexpirydate
      initialValues.policy_cover = policy_cover
      initialValues.rate = rate
      initialValues.prorata = prorata
      initialValues.suminsured = suminsured
      initialValues.policyriskitemid = policyRiskItemId
      initialValues.riskitemname = riskitemname
      initialValues.riskitemid = riskitemid
      initialValues.policy_cover_id = policy_cover_id
      initialValues.policynumber = policynumber
      initialValues.effectivedate = effectiveDate
      initialValues.policyid = policyid
      const requestMetadata = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(initialValues),
      }
      const response = await apiRequest(
        process.env.REACT_APP_BASE_URL +
          `/Policy/EditRiskItemForPolicy`, 'POST', initialValues
      )
      if(response.success)
      {
        toast.success('Risk item updated successfully.')
        window.location.href = '/endorsedpolicy'
      }else{
        toast.error('Something went wrong. Please try again.')
      }
    } else if (localStorage.productId == 3 || localStorage.productId == 5) {
      if (localStorage.productId == 3) {
        initialValuesForFCP.suminsured = suminsured
        initialValuesForFCP.monthlypremium = monthlypremium
        initialValuesForFCP.premiumfactor = premiumfactor
        initialValuesForFCP.membername = membername

        initialValuesForFCP.policy_cover = ''
        initialValuesForFCP.rate = 0
        initialValuesForFCP.itempstartdate = ''
        initialValuesForFCP.riskitemid = ''
        initialValuesForFCP.riskitemname = ''
        initialValuesForFCP.policy_cover_id = 0
        initialValuesForFCP.policynumber = ''
        initialValuesForFCP.prorata = 0
        initialValuesForFCP.policyriskitemid = policyRiskItemId
        initialValuesForFCP.address = ''
        initialValuesForFCP.annualpremium = 0
        initialValuesForFCP.termpremium = 0
        initialValuesForFCP.gender = ''
        initialValuesForFCP.age = ''
        initialValuesForFCP.relationship = ''
        initialValuesForFCP.grand_total = 0
        initialValuesForFCP.monthlypremium = 0
        console.log(initialValuesForFCP)
        const requestMetadata = {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(initialValuesForFCP),
        }
        fetch(
          process.env.REACT_APP_BASE_URL +
            `/Policy/EditRiskItemForPolicy?productid=${productId}`,
          requestMetadata,
        )
          .then(res => res.json())
          .then(data => {
            window.location.href = '/endorsedpolicy'
          })
      } else if (localStorage.productId == 5) {
        initialValuesForFCP.suminsured = suminsured
        initialValuesForFCP.monthlypremium = monthlypremium
        initialValuesForFCP.premiumfactor = premiumfactor
        initialValuesForFCP.membername = membername

        initialValuesForFCP.policy_cover = policy_cover
        initialValuesForFCP.rate = rate
        initialValuesForFCP.itempstartdate = ''
        initialValuesForFCP.riskitemid = riskItemIdForHCP.toString()
        initialValuesForFCP.riskitemname = riskitemname
        initialValuesForFCP.policy_cover_id = riskCoverIdForHCP
        initialValuesForFCP.policynumber = ''
        initialValuesForFCP.prorata = 0
        initialValuesForFCP.policyriskitemid = policyRiskItemId
        initialValuesForFCP.address = ''
        initialValuesForFCP.annualpremium = 0
        initialValuesForFCP.termpremium = 0
        initialValuesForFCP.gender = ''
        initialValuesForFCP.age = ''
        initialValuesForFCP.relationship = ''
        initialValuesForFCP.grand_total = 0
        initialValuesForFCP.monthlypremium = 0
        console.log(initialValuesForFCP)
        const requestMetadata = {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(initialValuesForFCP),
        }
        fetch(
          process.env.REACT_APP_BASE_URL +
            `/Policy/EditRiskItemForPolicy?productid=${productId}`,
          requestMetadata,
        )
          .then(res => res.json())
          .then(data => {
            window.location.href = '/endorsedpolicy'
          })
      }
    }
  }

  const changeSumInsured = e => {
    setSumInsured(e.target.value)
  }

  const onRiskCoverChangeForHCP = async e => {
    console.log(e)
    await fetch(
      process.env.REACT_APP_BASE_URL +
        '/Product/GetRiskItembyId/' +
        e +
        ',' +
        localStorage.getItem('productId'),
    )
      .then(res => res.json())
      .then(data => {
        console.log(data)
        setRiskItemListForHCP(data.result)
        setPolicyCoverId(e)
        setPolicyCover(data.result[0].riskname)
      })
  }

  const onRiskItemChangeForHCP = async e => {
    console.log(e)
    let riskitem
    for (let i = 0; i < riskItemListForHCP.length; i++) {
      if (riskItemListForHCP[i].riskitemid == e) {
        riskitem = riskItemListForHCP[i]
        break
      }
    }
    setRiskCoverIdForHCP(riskitem.coverid)
    setRiskItemIdForHCP(riskitem.riskitemid)
    setRate(riskitem.ratepercentage)
    setRiskItemName(riskitem.riskitemname)

    console.log(riskitem)
  }

  const changeSumInsuredForFCP = e => {
    setSumInsured(parseFloat(e.target.value))
  }

  const findDayDifference = (date1, date2) => {
    return Math.floor(Math.abs(date2 - date1) / (1000 * 60 * 60 * 24))
  }

  const roundvalue = value => {
    if (value > 0) {
      return parseFloat(value.toString().match(/^-?\d+(?:\.\d{0,2})?/)[0])
    }
  }

  return (
    <div
      className="container-box"
      style={{margin: '15px auto 0', width: '100%', maxWidth: '100%'}}>
      <Spin spinning={loader}>
        <Row gutter={(2, [12])} style={{marginTop: '10px'}}>
          <Form onSubmit={handleSubmit}>
            {localStorage.productId != 3 && localStorage.productId != 5 ? (
              <Col xs={24} md={12} lg={12}>
                <Form.Item className="d-flex-input" label="Address:">
                  <Input
                    type="text"
                    placeholder={address}
                    onChange={changeAddress}
                  />
                </Form.Item>
              </Col>
            ) : null}

            {localStorage.productId == 3 || localStorage.productId == 5 ? (
              <Col xs={24} md={12} lg={12}>
                <Form.Item className="d-flex-input" label="Members Name:">
                  <input
                    type="text"
                    placeholder={membername}
                    onChange={changeMembersName}
                  />
                </Form.Item>
              </Col>
            ) : null}

            {localStorage.productId == 3 || localStorage.productId == 5 ? (
              <Col xs={24} md={12} lg={12}>
                <Form.Item className="d-flex-input" label="Age:">
                  <input type="text" placeholder={age} disabled />
                </Form.Item>
              </Col>
            ) : null}

            {localStorage.productId != 3 && localStorage.productId != 5 ? (
              <Col xs={24} md={12} lg={12}>
                <Form.Item className="d-flex-input" label="Annual Premium:">
                  <input type="text" placeholder={annualPremium} disabled />
                </Form.Item>
              </Col>
            ) : null}
            {localStorage.productId != 3 && localStorage.productId != 5 ? (
              <Col xs={24} md={12} lg={12}>
                <Form.Item className="d-flex-input" label="Term Premium:">
                  <input type="text" placeholder={termPremium} disabled />
                </Form.Item>
              </Col>
            ) : null}

            <Col xs={24} md={12} lg={12}>
              <Form.Item className="d-flex-input" label="Start Date:">
                <DatePicker
                  style={{width: '100%'}}
                  value={moment(itempstartdate, dateFormat)}
                  disabled
                />
              </Form.Item>
            </Col>

            {localStorage.productId != 3 && localStorage.productId != 5 ? (
              <Col xs={24} md={12} lg={12}>
                <Form.Item
                  className="d-flex-input"
                  label="Expiry Date:"
                  disabled>
                  <DatePicker
                    style={{width: '100%'}}
                    value={moment(itempexpirydate, dateFormat)}
                    selected={itempexpirydate}
                    disabled
                  />
                </Form.Item>
              </Col>
            ) : null}
            {localStorage.productId != 3 && localStorage.productId != 5 ? (
              <Col xs={24} md={12} lg={12}>
                <Form.Item className="d-flex-input" label="Effective Date:">
                  <DatePicker
                    style={{width: '100%'}}
                    //   onChange={changeEffectiveDate}
                    value={moment(effectiveDate, dateFormat)}
                    disabled
                  />
                </Form.Item>
              </Col>
            ) : null}
            {localStorage.productId != 3 && localStorage.productId != 5 ? (
              <Col xs={24} md={12} lg={12}>
                <Form.Item className="d-flex-input" label="Sum Insured:">
                  <Input
                    type="text"
                    placeholder={suminsured}
                    onChange={changeSumInsured}
                  />
                </Form.Item>
              </Col>
            ) : null}

            {localStorage.productId == 3 && localStorage.productId != 5 ? (
              <Col xs={24} md={12} lg={12}>
                <Form.Item
                  className="d-flex-input"
                  label="Sum Insured For FCP:">
                  <Input
                    type="text"
                    placeholder={suminsured}
                    onChange={changeSumInsuredForFCP}
                  />
                </Form.Item>
              </Col>
            ) : null}

            <Col xs={24} md={12} lg={12}>
              <Form.Item className="d-flex-input" label="Rate:">
                <input type="text" placeholder={rate} disabled />
              </Form.Item>
            </Col>

            {localStorage.productId == 3 && (
              <Col xs={24} md={12} lg={12}>
                <Form.Item className="d-flex-input" label="Premium Factor:">
                  <input type="text" placeholder={premiumfactor} disabled />
                </Form.Item>
              </Col>
            )}

            {localStorage.productId == 3 && (
              <Col xs={24} md={12} lg={12}>
                <Form.Item className="d-flex-input" label="Monthly Premium:">
                  <input type="text" placeholder={monthlypremium} disabled />
                </Form.Item>
              </Col>
            )}

            {localStorage.productId != 3 && localStorage.productId != 5 ? (
              <Col xs={24} md={12} lg={12}>
                <Form.Item className="d-flex-input" label="Prorata Premium: ">
                  <input type="text" placeholder={prorata} disabled />
                </Form.Item>
              </Col>
            ) : null}
            {localStorage.productId != 3 && localStorage.productId != 5 ? (
              <Col xs={24} md={12} lg={12}>
                <Form.Item className="d-flex-input" label="Risk Item: ">
                  <input type="text" placeholder={riskitemname} disabled />
                </Form.Item>
              </Col>
            ) : null}

            {localStorage.productId == 5 ? (
              <Col xs={24} md={12} lg={12}>
                <Form.Item
                  className="d-flex-input"
                  label="Risk Cover for HCP: ">
                  <Select
                    placeholder={policy_cover}
                    onChange={onRiskCoverChangeForHCP}>
                    {riskCoverListForHCP.map(option => (
                      <Option key={option.riskcoverid}>
                        {option.riskname}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            ) : null}

            {localStorage.productId == 5 ? (
              // Risk Item for HCP
              <Col xs={24} md={12} lg={12}>
                <Form.Item className="d-flex-input" label="Risk Item : ">
                  <Select
                    type="text"
                    placeholder={riskitemname}
                    onChange={onRiskItemChangeForHCP}>
                    {riskItemListForHCP.map(option => (
                      <Option key={option.riskitemid}>
                        {option.riskitemname}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
                <Form.Item className="btn-group-success">
                  <button
                    htmlType="submit"
                    size="default"
                    className="ant-btn btn-success">
                    Submit
                  </button>
                </Form.Item>
              </Col>
            ) : null}

            {localStorage.productId != 5 ? (
              // Risk Cover for HCP
              <Col xs={24} md={12} lg={12}>
                <Form.Item className="d-flex-input" label="Risk Cover: ">
                  <input type="text" placeholder={policy_cover} disabled />
                </Form.Item>
                <Form.Item className="btn-group-success">
                  <button
                    htmlType="submit"
                    size="default"
                    className="ant-btn btn-success">
                    Submit
                  </button>
                </Form.Item>
              </Col>
            ) : null}
          </Form>
        </Row>
      </Spin>
    </div>
  )
}

const WrappedEditPolicyPopUp = Form.create({name: 'Homeinsurance_list'})(
  EditPolicyPopUp,
)

export default EditPolicyPopUp
